export interface BaseFilters {
  limit?: number;
  page?: number;
  skip?: number;
  sort?: string;
}

export function adaptPaginationForApi<T extends BaseFilters>(filters: T): T {
  const filtersForApi = { ...filters, skip: filters.limit * (filters.page - 1) };
  delete filtersForApi.page;

  return filtersForApi;
}
